/**
 * Find intersection from two given ranges
 * https://scicomp.stackexchange.com/a/26260
 */
export function findRangeIntersection(arr1: [number, number], arr2: [number, number]) {
  const [arr1RangeStart, arr1RangeEnd] = arr1;
  const [arr2RangeStart, arr2RangeEnd] = arr2;

  if (arr1RangeEnd < arr2RangeStart || arr2RangeEnd < arr1RangeStart) return undefined;

  const leftLimit = Math.max(arr1RangeStart, arr2RangeStart);
  const rightLimit = Math.min(arr1RangeEnd, arr2RangeEnd);
  return [leftLimit, rightLimit];
}

export function generateRandomNumber() {
  return Math.floor(Math.random() * 1000000000);
}

export function randomBetween(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function precisionRound(value: number, precision: number) {
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
}

/**
 * Position in percentage
 * i.e. min 20, max 50, value 35 is half way so position is 50%
 */
export function valuePositionInBracket(min: number, max: number, value: number) {
  return precisionRound(Math.abs(((value - min) / (max - min)) * 100), 0);
}
